export const MAX_AUTH_TOKEN_ATTEMPTS = 5;
export const AUTH_TOKEN_DELAY = 30000;
